import { useEffect } from "react";
// import DefaultLayout from "../../components/layout/DefaultLayout";
import EditProfileSection from "../../components/sections/profile/EditProfileSection";
import SecuritySection from "../../components/sections/profile/SecuritySection";
import { useNavigate } from "react-router-dom";
import DefaultLayout from "../../components/layout/DefaultLayout";
export default function Profile() {
  const navigate = useNavigate(); 
 const token= localStorage.getItem('token');
useEffect(()=>{
  if (!token){
    navigate('/')
   }
},)
  return (
    <DefaultLayout>
      <div className="container px-10 m-auto py-10 md:py-20">
      <EditProfileSection />
       <SecuritySection />
      </div>
    </DefaultLayout>
  );
}
